/**
 * Back to Top Button Functionality
 * Shows/hides the back to top button based on scroll position
 */

(function() {
    'use strict';

    // Configuration - scroll threshold in pixels
    const SCROLL_THRESHOLD = 250;

    /**
     * Initialize back to top functionality
     */
    function initBackToTop() {
        const backToTopButton = document.querySelector('.qld__back-to-top');
        
        if (!backToTopButton) {
            return;
        }

        /**
         * Handle scroll events to show/hide the back to top button
         */
        function handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            if (scrollTop > SCROLL_THRESHOLD) {
                backToTopButton.classList.add('active');
            } else {
                backToTopButton.classList.remove('active');
            }
        }

        // Add scroll event listener with throttling for better performance
        let ticking = false;
        
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(handleScroll);
                ticking = true;
            }
        }

        function onScroll() {
            ticking = false;
            requestTick();
        }

        // Attach scroll event listener
        window.addEventListener('scroll', onScroll, { passive: true });

        backToTopButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Scroll to top
            window.scrollTo({
                top: 0,
                behavior: 'auto'
            });
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBackToTop);
    } else {
        initBackToTop();
    }

})();
